import $ from "jquery";
import scroll from "scroll";

function toggleSidebar() {
  if ($(window).width() <= 480) {
    scroll.toggleSidebar();
  }
}

function init() {
  var $sidebar = $('.sidebar'),
    $siteHeaderWrapper = $("#viihde-top-navigation-placeholder"),
    hideNaviOnScroll = $('html').hasClass('hide-local-navi-on-scroll');

  if (hideNaviOnScroll) {
    scroll.window.onValue(function(scrollTop) {
      $sidebar.css("padding-top", Math.max(0, $siteHeaderWrapper.height() - scrollTop));
    });
  }

  $('#sidebar-toggle-button').click(toggleSidebar);
  $('.sidebar, #folders').click(toggleSidebar);
}

export default {
  init: init,
};



// WEBPACK FOOTER //
// ./web/js/components/sidebar.js